import React, { useState } from "react";
import { Col, Row, List, Tooltip } from "antd";
import HelpIcon from "../icons/helpIcon";

function DataFieldList(props) {

    const [collapse, setCollapse] = useState(false);

    function renderHelpText()
    {
        return (
            <Tooltip placement="top" title={props.helpText}>
                <HelpIcon style={{marginLeft: 6}}/>
            </Tooltip>            
        );
    }

    function renderLabelOrList() {
        if (collapse) {
            return (
                <List
                    className="data-field-list"
                    itemLayout="horizontal"
                    dataSource={props.list}
                    renderItem={item => (
                        <List.Item className="data-field-list-item">
                            {item}
                        </List.Item>
                    )}
                />
            )
        } else {
            return(
                <>
                    <span className={"data-field-list-value"}>{props.list[0]}</span>                    
                    {props.list.length > 1 ? <span className={"data-field-list-count"}>{`+${props.list.length - 1}`}</span> : null}                    
                </>
            )
        }
    }

    function renderBorderBottom() {
        if (props.noBorder) {
            return "unset"
        } else {
            return "1px solid #eceef1"
        }
    }

    return (
        <>
            <Row gutter={20} style={{
                borderBottom: renderBorderBottom(),
                paddingBottom: 16,
                marginTop: 16,
                display: "flex",
                alignItems: "top"
            }}>
                <Col span={2}>
                    <span className={"data-field-list-label"}>{props.label}{props.helpText ? renderHelpText() : ""}</span>
                </Col>
                <Col span={20}>
                    {renderLabelOrList()}
                </Col>
                <Col span={2} style={{textAlign: "right"}}>
                    {props.list.length > 1 ?
                        <a key="back" className={"account-link"}
                            onClick={() => setCollapse(!collapse)}>{collapse ? "Ver menos" : "Ver mais"}
                        </a>
                        : null
                    }
                </Col>
            </Row>
        </>
    )
}

export default DataFieldList;